
var commonUtility = require('./commonUtility.js');
var stringUtil = require('../string/stringUtil.js');
var constants = require('../domain/constants.js');
var floorLayoutUtil = require('../domain/floorLayoutUtil.js');
var stateManager = require('../state/stateManager.js');


module.exports.getAllStorefronts = function()
{
    return commonUtility.getPropertyStorefronts();
}

module.exports.getStorefrontById = function(storefrontId)
{
    const storefront = this.getAllStorefronts().find(sf => stringUtil.areStringSame(sf.id, storefrontId));
    return storefront;
}

module.exports.getPOSStorefronts = function()
{
    var allStorefronts = this.getAllStorefronts();
    return allStorefronts.filter(s => stringUtil.areStringSame(s.type, constants.storefrontTypes.POS));
}

module.exports.getCurrentStorefront = function()
{
    var allStorefronts = this.getAllStorefronts();
    return allStorefronts.find(s => stringUtil.areStringSame(s.id, stateManager.getStore().getState().currentStorefrontId));
}

module.exports.getCurrentStorefrontVenueCode = function()
{
    return this.getStorefrontVenueCode(this.getCurrentStorefront());
}

module.exports.isStorefrontEnableForPayOverPhone = function (storefrontId)
{
    const storefront = this.getStorefrontById(storefrontId);
    const webAppConfiguration = storefront.webAppConfiguration; 
    return webAppConfiguration && webAppConfiguration.isEnabled && stringUtil.areStringSame(webAppConfiguration.paymentProvider, constants.WebPaymentProviders.stripeOverPhone);
}

module.exports.getPayOverPhoneWebConfiguration = function (storefrontId)
{
    if(!this.isStorefrontEnableForPayOverPhone(storefrontId))
        return null;

    const storefront = this.getStorefrontById(storefrontId);
    return storefront.webAppConfiguration; 
}

module.exports.getStorefrontVenueCode = function(storefront)
{
    if (storefront.type ==  constants.storefrontTypes.Deliveroo)
        return constants.VenueCodeDeliveroo;

    if (storefront.type ==  constants.storefrontTypes.UberEats)
        return constants.VenueCodeUberEats;

    if (storefront.type ==  constants.storefrontTypes.JustEats)
        return constants.VenueCodeJustEats;

    if (storefront.type ==  constants.storefrontTypes.ExternalApp)
        return constants.VenueCodeExternalApp;

    if (storefront.type ==  constants.storefrontTypes.FlipdishWebApp ||
        storefront.type ==  constants.storefrontTypes.FlipdishKIOSK ||
        storefront.type ==  constants.storefrontTypes.FlipdishMobileApp)
        return constants.VenueCodeFlipdish;

    if (storefront.type ==  constants.storefrontTypes.WebApp)
        return constants.VenueCodeWebApp;

    if (storefront.type ==  constants.storefrontTypes.MobileApp)
        return constants.VenueCodeMobileApp;

    return constants.VenueCodeProperty
}

module.exports.canHaveTableAssignment = function(storefront)
{
    const storefrontOperatingConfiguration = storefront.operatingConfiguration || {};

    if (!floorLayoutUtil.doesHaveFloorLayout)
        return false;

    return  storefrontOperatingConfiguration.dineInRequiresOrderReference == constants.triStateFlag.optional || 
            storefrontOperatingConfiguration.dineInRequiresOrderReference == constants.triStateFlag.always;
}

module.exports.canHavePagerNumber = function(storefront)
{
    const storefrontOperatingConfiguration = storefront.operatingConfiguration || {};

    return  storefrontOperatingConfiguration.takeAwayRequiresOrderReference == constants.triStateFlag.optional || 
            storefrontOperatingConfiguration.takeAwayRequiresOrderReference == constants.triStateFlag.always;
}
